import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { apiGet, handleApiError } from '../../common';

export default class UniqueEmailInput extends Component {
  state = {
    inputValue: this.props.value || '',
  };

  UNSAFE_componentWillMount() {
    this.debouncedUniqueValidation = _.debounce(this.uniqueValidation, 250);
  }

  render() {
    return (
      <StyledInput
        type="email"
        name="email"
        required
        value={this.state.inputValue}
        onChange={this.handleChange}
        readOnly={this.props.readonly}
      />
    );
  }

  handleChange = (e) => {
    const { value } = e.target;

    this.setState({ inputValue: value }, () => this.debouncedUniqueValidation(value));
  };

  uniqueValidation = (inputValue) => {
    apiGet(
      this.props.emailValidateUrl + encodeURIComponent(inputValue),
      {},
      (isUnique) => {
        this.props.isUniqueCb(isUnique);
      },
      handleApiError(),
    );
  };
}

const StyledInput = styled.input`
  &:read-only {
    background-color: ${({ theme }) => theme.colors.on[50]};
    color: ${({ theme }) => theme.colors.on[600]};
  }
`;
